import { createWithEqualityFn } from 'zustand/traditional';
import { config } from '@shakkerai/config';
// import { isOverseas } from '@shakkerai/pro-utils';
const isOverseas = config.env === 'aws';
const globalMode = localStorage.getItem('__MODE_SETTINGS_Key__') || 'simple';

export const _useTempState = createWithEqualityFn((set) => ({
  // 画布操作状态
  currentCanvasTool: 'select',
  dragging: false,
  spacePressing: false,
  newerGuideTipOpen: false,

  hiddenElementIds: {},

  promptLang: isOverseas ? 'en' : 'zh',
  promptSettingsParams: {
    prompt_setting_enhance: true,
    auto_complete: true,
    two_language: true,
  },

  // 框选矩形数据
  selectionRect: null,

  // 全局模式:simple/pro
  globalMode: globalMode,

  // 从图片提取提示词，原图对象「url，id」
  imagePromptElement: null,

  // 用于绘制图片上层的内容（智能擦除）
  segmentsShapes: [],
  brushSize: 60,
  eraserSize: 60,
  editorToolbarSelectedType: 'lasso',
  // 以上是预设的一些临时状态，
  // 可随意在此维护任意临时状态
  historyWorkflowShow: false,
  // 绘制蒙版缓存shapes
  shapesCache: [],
  // 统一替换图片列表
  replaceList: [],
  presetColorRandomArr: [],
  presetColorRandomArrPointer: 0,
  isMaskExist: true,
}));

export const useTempState = (field, fallbackValue) => {
  if (field === false) {
    return _useTempState.getState();
  }

  return _useTempState(field ? (state) => state[field] || fallbackValue : undefined);
};

export const setTempState = (partialState, value) => {
  _useTempState.setState(typeof partialState === 'string' ? { [partialState]: value } : partialState);
};

export const getTempState = (fieldName, fallbackValue) => {
  return fieldName ? _useTempState.getState()[fieldName] || fallbackValue : _useTempState.getState();
};
